<template>
    <div>
        <div class="dashboard-table-column text-wrap text-center d-block">
            <p>Совершая оплату вы  подтверждаете, что оплачиваете только со своего банковского счета КР и согласны на ручную проверку транзакции, которая может занять до 8 часов.</p>
            <hr>
            <p>Для пополнения вам необходимо отправить банковский перевод по следующим реквизитам:</p>
        </div>
        <label class="form-label">Название</label>
        <div class="form-group mb-2 position-relative">
            <input type="text" class="form-input sm" value="ОсОО Байсанар" ref="osoo" readonly :disabled="loading">
            <span class="form-icon icon-paste ease" v-on:click="copy('osoo')"></span>
        </div>
        <label class="form-label">Расчетный счет</label>
        <div class="form-group mb-2 position-relative">
            <input type="text" class="form-input sm" value="1033020000249420" ref="account" readonly :disabled="loading">
            <span class="form-icon icon-paste ease" v-on:click="copy('account')"></span>
        </div>
        <label class="form-label">БИК</label>
        <div class="form-group mb-2 position-relative">
            <input type="text" class="form-input sm" value="103030" ref="bik" readonly :disabled="loading">
            <span class="form-icon icon-paste ease" v-on:click="copy('bik')"></span>
        </div>
        <label class="form-label">ИНН</label>
        <div class="form-group mb-2 position-relative">
            <input type="text" class="form-input sm" value="01105202310063" ref="inn" readonly :disabled="loading">
            <span class="form-icon icon-paste ease" v-on:click="copy('inn')"></span>
        </div>
        <label class="form-label">Код платежа</label>
        <div class="form-group mb-2 position-relative">
            <input type="text" class="form-input sm" value="42161000 - Услуги по покупке и продаже ВА" readonly :disabled="loading">
            <span class="form-icon icon-paste ease" v-on:click="copy('payment-code', '42161000')"></span>
        </div>
        <label class="form-label">Назначение платежа</label>
        <div class="form-group mb-2 position-relative">
            <input type="text" class="form-input sm" value="Покупка ВА" ref="assignment-payment" readonly :disabled="loading">
            <span class="form-icon icon-paste ease" v-on:click="copy('assignment-payment')"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    },
    methods: {
        copy(ref, value = '') {
            if(value) {
                navigator.clipboard.writeText(value)
            } else {
                this.$refs[ref].select()
                document.execCommand('copy')
                this.$refs[ref].blur()
                window.getSelection().removeAllRanges()
                this.$store.dispatch('notification', { message: 'Скопировано', type: 'success' })
            }
        }
    }
}
</script>